import { useContext } from 'react';
import { CarouselItemStateContext } from '../CarouselItemStateContext';

export const useCarouselItemState = () => {
  const carouselItemState = useContext(CarouselItemStateContext);

  if (!carouselItemState) {
    throw new Error(
      'The hook useCarouselItemState should be used only inside ' +
        'the carousel item element.'
    );
  }

  return carouselItemState;
};
